import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5876 14.0064c-.2485-.124-1.4703-.7234-1.6981-.8062-.2278-.0827-.3934-.124-.5591.124-.1656.2481-.6418.8063-.7868.9717-.1449.1653-.2899.186-.5384.062-.2485-.1241-1.0492-.3857-1.9983-1.23-.7388-.657-1.23751-1.4685-1.38248-1.7166-.14496-.248-.01545-.3821.10897-.5056.11178-.1111.24854-.2895.37281-.4342.1242-.1447.1656-.2481.2484-.4134.0828-.1654.0414-.3101-.0207-.43412-.0621-.12401-.55907-1.34377-.76613-1.83993-.20171-.48312-.40657-.41769-.55912-.4254-.14478-.00713-.31063-.00865-.47629-.00865-.16567 0-.43486.06196-.66261.30999C7.64196 7.90812 7 8.50761 7 9.72727c0 1.21973.8904 2.39793 1.01467 2.56343.12423.1653 1.75229 2.6682 4.24503 3.7416.5929.2553 1.0558.4078 1.4166.522.5954.1886 1.1371.162 1.5653.0982.4774-.0712 1.4702-.5995 1.6773-1.1783.207-.5789.207-1.075.1449-1.1783-.0621-.1034-.2277-.1654-.4762-.2895zM12.0251 20.15h-.0033c-1.4849-.0006-2.94126-.3981-4.21174-1.1495l-.30218-.1788-3.13185.8188.83593-3.0433-.19678-.312c-.82829-1.313-1.2658-2.8306-1.26518-4.3889C3.75181 7.34934 7.46396 3.65 12.0284 3.65c2.2103.00071 4.2879.8597 5.8502 2.41858C19.441 7.62732 20.3008 9.69941 20.3 11.9029c-.0019 4.5475-3.714 8.2471-8.2749 8.2471zM19.086 4.90642C17.2059 3.03313 14.7056 2.00109 12.0418 2c-5.48886 0-9.95609 4.44555-9.95829 9.9098-.00071 1.7468.45781 3.4516 1.32927 4.9547L2 22l5.27901-1.3782c1.4545.7896 3.09209 1.2057 4.75869 1.2063h.0042c5.4881 0 9.9559-4.446 9.9581-9.9104.001-2.64804-1.0338-5.13804-2.914-7.01128z",
    fill: "currentColor"
  }));
});